import { compOnlyCoverageInsOps, liabilityCoverageInsOps } from "./builders/coverages";
import { createEndorsementsMap } from "./builders/createEndorsementsMap";
import { getMockHousehold } from "./builders/getMockHousehold";
import { getMockPolicyAddressInsOps } from "./builders/getMockPolicyAddress";
import { getMockRevalVehicles } from "./builders/getMockVehicles";

export const revalEndorsements = createEndorsementsMap({
  "abc123-endo": {
    PolicyNumber: "abc123",
    Premium: 6000,
    ProratedFinalEndorsementPremium: 6000,
    FinalPremium: 6000,
    StateRegion: "MD",
    StateRegionDescription: "Maryland",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("cobra", "superBee"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "def456-endo": {
    PolicyNumber: "def456",
    Premium: 15500,
    ProratedFinalEndorsementPremium: 15500,
    FinalPremium: 15500,
    StateRegion: "KS",
    StateRegionDescription: "Kansas",
    PolicyCoverages: compOnlyCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("ferrari"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "dc101-endo": {
    PolicyNumber: "dc101",
    Premium: 551,
    ProratedFinalEndorsementPremium: 551,
    FinalPremium: 551,
    StateRegion: "QC",
    StateRegionDescription: "Quebec",
    PolicyCoverages: compOnlyCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("sportScoutRacer"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "5R34843-00-endo": {
    PolicyNumber: "5R34843-00",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "MD",
    StateRegionDescription: "Maryland",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("cobra"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "5R34843-01-endo": {
    PolicyNumber: "5R34843-01",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "MD",
    StateRegionDescription: "Maryland",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("cobra"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "5R34843-02-endo": {
    // Future Policy version
    PolicyNumber: "5R34843-02",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "MD",
    StateRegionDescription: "Maryland",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("cobra"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "EA108939-00-endo": {
    // Old Policy version
    PolicyNumber: "EA108939-00",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "GA",
    StateRegionDescription: "Georgia",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("sportScoutRacer"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "EA108939-01-endo": {
    PolicyNumber: "EA108939-01",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "GA",
    StateRegionDescription: "Georgia",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("sportScoutRacer"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "EA108939-02-endo": {
    PolicyNumber: "EA108939-02",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "GA",
    StateRegionDescription: "Georgia",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("sportScoutRacer"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "CD829471-00-endo": {
    PolicyNumber: "CD829471-00",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "BC",
    StateRegionDescription: "British Columbia",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("crv"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "CD829471-01-endo": {
    PolicyNumber: "CD829471-01",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "BC",
    StateRegionDescription: "British Columbia",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("crv"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "CD829471-02-endo": {
    PolicyNumber: "CD829471-02",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "BC",
    StateRegionDescription: "British Columbia",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("crv"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "RG263345-00-endo": {
    PolicyNumber: "RG263345-00",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "AB",
    StateRegionDescription: "Alberta",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("cobra", "mustang"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "RG263345-01-endo": {
    PolicyNumber: "RG263345-01",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "AB",
    StateRegionDescription: "Alberta",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("cobra", "mustang"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
  "RG263345-02-endo": {
    PolicyNumber: "RG263345-02",
    Premium: 5500,
    ProratedFinalEndorsementPremium: 5500,
    FinalPremium: 5500,
    StateRegion: "AB",
    StateRegionDescription: "Alberta",
    Agency: { Id: 3000, Name: "Mr Broker Man" },
    PolicyCoverages: liabilityCoverageInsOps,
    IsRevaluationProgram: true,
    Vehicles: getMockRevalVehicles("cobra", "mustang"),
    Household: getMockHousehold(),
    PolicyAddress: getMockPolicyAddressInsOps(),
  },
});

export type MockEndorsementId = keyof typeof revalEndorsements;
